import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface UmuturageData {
  id: string;
  issueId: string;
  umuturageId: string;
  amazina: string;
  indangamuntu: string;
  yearOfBith: string;
  sex: string;
  telephone: string;
  email: string;
  village: string;
  cellName: string;
  sectorName: string;
  districtCode: string;
  districtName: string;
  provinceCode: string;
  provinceName: string;
  imiterere: string;
  icyakorwa: string;
  icyakozwe: string;
  umwanzuro: string;
  issueDate: string;
  categoryName: string;
  groupName: string;
  statusName: string;
  senderName: string;
  senderPhone: string;
  sourceName: string;
  govinst: string;
}

@Injectable({
  providedIn: 'root',
})
export class UmuturageService {
  constructor(private api: ApiService) {}

  getAllUmuturageData(): Observable<UmuturageData[]> {
    return this.api.GET<UmuturageData[]>('umuturage-data');
  }

  getUmuturageDataById(id: string): Observable<UmuturageData> {
    return this.api.GET<UmuturageData>(`umuturage-data/${id}`);
  }
}
